import Colors from "../../../theme/colors";

export const style = {
  container: {
    backgroundColor: "#FFFFFF",
    border: "1px solid #0000001A",
    borderRadius: "8px",
    height: "100",
  },
  search: {
    display: "flex",
    justifyContent: "space-between",
    gap: "20px",
  },
  searchInput: {
    width: "40%",
    // border: "1px solid #A4A4A4",
    borderRadius: "0.5rem",
  },
  tableContainer: {
    backgroundColor: Colors.white,
    // border: "1px solid red",
    // position: "relative",
    overflowX: "scroll",
  },
  tableTitle: {
    color: "#8C8C8C",
    fontSize: "1.2rem",
    fontWeight: 500,
    marginBottom: "1rem",
    // border: "1px solid red",
  },
  tableHeading: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "0.5rem",
    color: "#8C8C8C",
    whiteSpace: "nowrap",
    // overflow: "hidden",
    // textOverflow: "ellipsis",
    // border: "1px solid red",
  },
  tableRow: {
    backgroundColor: "#FFFFFF",
    border: "1px solid red",
    color: "#183053",
    textAlign: "left",
    // whiteSpace: "nowrap",
    // overflow: "hidden",
    // textOverflow: "ellipsis",
  },
  applyButton: {
    width: "100px",
    fontWeight: 500,
  },
  disableButton: {
    color: "#8C8C8C",
    border: "1px solid #8C8C8C",
    borderRadius: "0.5rem",
    padding: "0.3rem 1.5rem",
    fontWeight: 500,
  },
  searchButton: {
    color: "#FFFFFF",
    borderRadius: "0.5rem",
    padding: "0.5rem 3rem",
  },
  pagination: {
    display: "flex",
    justifyContent: "center",
    margin: "20px 0",
  },
  rowStyleId: {
    color: "#043D90",
    fontWeight: 500,
    textAlign: "left",
  },
  rowStyle: {
    color: "#183053",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "left",
  },
  customTable: {
    border: "none",
  },
  rowStyleInfo: {
    display: "flex",
    // border: "1px solid red",
  },
  searchDropdown: {
    width: "40%",
    border: "1px solid #A4A4A4",
    borderRadius: "0.5rem",
  },
  mediumItem: {
    flex: "1 1 28%",
  },
  existingGZ: {
    display: "flex",
    alignItems: "left",
    gap: 8,
    marginTop: 10,
  },
  Cell: {
    color: Colors.mediumBlue,
    fontSize: "12px",
    padding: "16px 10px",
    textAlign: "left",
  },
  status: {
    border: "1px solid #043D90",
    borderRadius: "12px",
    fontWeight: "600",
    fontSize: "10px",
    padding: "6px",
    background: "#E2EEFF",
    minWidth: "84px",
    width: "fit-content",
    whiteSpace: "nowrap",
    textAlign: "center",
  },
  ActionBtnContainer: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "12px",
  },
  actionBtn: {
    fontSize: "10px",
    width: "100px",
  },
  cardContainer: {
    width: "98%",
    margin: "5px auto",
    minHeight: "70vh",
  },
  icon: {
    cursor: "pointer",
    marginRight: "16px",
    fontSize: "12px",
  },
  flexC: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  date: {
    display: "flex",
    // position: "relative",
  },
  tableCell: {
    textAlign: "left",
    border: "none",
  },
  rowStyleOS: {
    color: "#183053",
    textAlign: "left",
  },
  typogrphyStyleId: {
    color: "#043D90",
    fontSize: "0.875rem",
    textAlign: "left",
    fontWeight: 500,
  },
  typogrphyStyle: {
    color: "#183053",
    fontSize: "0.875rem",
    textAlign: "left",
  },
  tableHeadCells: {
    // padding: "8px",
    color: "#000000",
    fontWeight: 600,
    background: "#BAD9EC",
  },
};

export const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
  },
  mini: {
    maxWidth: "5rem",
  },
  small: {
    maxWidth: "6rem",
  },
  medium: {
    maxWidth: "10rem",
  },
};
